import {useRouter} from 'next/router';
import {MouseEvent, SyntheticEvent, useCallback} from 'react';
import {aggregateAndSendLog} from '../../logging/aggregateAndSendLog';
import {putTiaraObjectProps} from '../../logging/putTiaraObjectProps';
import {MobileCommentHeader} from '../organisms/MobileCommentHeader/MobileCommentHeader';

interface MobileLayoutCommentHeaderProps {
  headerTitle?: string;
  onClickBack: (e: SyntheticEvent) => void;
}

export function MobileLayoutCommentHeader({
  headerTitle = '',
  onClickBack,
}: MobileLayoutCommentHeaderProps) {
  const router = useRouter();

  const onClickContentHome = useCallback(
    (e: MouseEvent) => {
      aggregateAndSendLog({
        targetElem: e.target as HTMLElement,
        eventMeta: {
          id: String(router.query.seriesId),
          type: 'seriesId',
          series_id: String(router.query.seriesId),
        },
        actionType: 'Event',
        actionName: '작품홈_클릭',
        customProps: {
          user_action: 'click',
        },
      });
      router.push(`/content/${router.query.seriesId}`);
    },
    [router]
  );

  return (
    <MobileCommentHeader
      title={headerTitle}
      onClickBack={onClickBack}
      onClickContentHome={onClickContentHome}
      {...putTiaraObjectProps({
        ...(router.query.productId
          ? {
              customProps: {event_episode_id: String(router.query.productId)},
            }
          : undefined),
      })}
    />
  );
}
